module.exports = __webpack_public_path__ + "static/media/fast-forward.b11296b0.svg";